module.exports = __webpack_public_path__ + "img/header-engagementRingsEssentials@2x.3efa547.jpg";